<template>
    <modal-dialog
        :value="value"
        @input="$emit('input', $event)"
        :title="$t('labels.edit')"
        :ok-loading="loading"
        :ok-disabled="false"
        :show-overlay="loadingUser"
        cancel-button
        @ok="save"
        @cancel="close"
    >
        <div v-if="item" class="mt-4">
            <div class="mb-2">
                <strong>{{ $t('labels.serial_number') }}:</strong>
                {{ item.serialNumber }}
            </div>

            <v-text-field
                v-model="editName"
                :label="$t('labels.name')"
                class="mb-4"
            />

            <entity-select-input
                v-model="selectedRestaurant"
                :label="$t('labels.restaurant')"
                :entity="selectApiClientType.RESTAURANT"
                autocomplete
                class="mb-4"
            />

            <entity-select-input
                v-model="selectedUser"
                :label="$t('labels.user')"
                :entity="selectApiClientType.USER"
                :query-params="{ restaurant: selectedRestaurant }"
                :request-disabled="!selectedRestaurant"
                autocomplete
                use-id-field
            />
        </div>
    </modal-dialog>
</template>

<script>
import ModalDialog from '@/components/dialog/ModalDialog'
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput'
import SelectApiClientType from '@/api/SelectApiClientType'
import TabletAutoLoginApiClient from '@/api/RestApi/TabletAutoLoginApiClient'
import UsersApiClient from '@/api/RestApi/UsersApiClient'
import Notification from '@/services/Notification/Notification'

export default {
    components: {
        ModalDialog,
        EntitySelectInput,
    },

    props: {
        value: Boolean,
        item: Object,
    },

    data() {
        return {
            selectApiClientType: SelectApiClientType,
            selectedRestaurant: null,
            selectedUser: null,
            editName: '',
            loading: false,
            loadingUser: false,
            skipRestaurantWatch: false,
        }
    },

    watch: {
        value(val) {
            if (val) {
                this.editName = this.item ? this.item.name || '' : ''
                this.loadCurrentUser()
            } else {
                this.selectedRestaurant = null
                this.selectedUser = null
                this.editName = ''
            }
        },
        selectedRestaurant() {
            if (this.skipRestaurantWatch) {
                this.skipRestaurantWatch = false
                return
            }
            this.selectedUser = null
        },
    },

    methods: {
        loadCurrentUser() {
            if (!this.item || !this.item.userId) return

            const userId =
                typeof this.item.userId === 'object'
                    ? this.item.userId.id
                    : null

            if (!userId) return

            this.loadingUser = true
            UsersApiClient.get(userId)
                .then((user) => {
                    const restaurantRole = (user.userRoles || []).find(
                        (r) => r.role === 'ROLE_RESTAURANT' && r.restaurant
                    )

                    if (restaurantRole && restaurantRole.restaurant) {
                        this.skipRestaurantWatch = true
                        this.selectedRestaurant =
                            restaurantRole.restaurant['@id']
                    }

                    this.$nextTick(() => {
                        this.selectedUser = userId
                    })
                })
                .finally(() => {
                    this.loadingUser = false
                })
        },

        close() {
            this.$emit('input', false)
        },

        save() {
            if (!this.item) return

            this.loading = true
            TabletAutoLoginApiClient.updateUser(this.item.id, this.selectedUser || null, this.editName)
                .then(() => {
                    Notification.success(this.$t('notifications.success'))
                    this.$emit('saved')
                })
                .catch(() => {
                    Notification.error(this.$t('notifications.error'))
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
